import { Button, Group, Stack, Center } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import Icon from '@ui/components/Icon/Icon';
import ContactsGroupsModal from 'src/new_arch/modules/workspaces/modals/ContactsGroupsModal/ContactsGroupsModal';
import Project from 'src/entities/project';
import ProjectRole from '@projectMembers/models/projectRole';
import EmailsInput from './EmailsInput/EmailsInput';
import useEmailInvite from './useEmailInvite';
import ManagersEmailsError from './ManagersEmailsError/ManagersEmailsError';

export type EmailInviteProps = {
	project: Project;
	addGroupModalStackOrder?: number;
	onRoleSelectionChange?: ( role: ProjectRole ) => void;
};

const EmailInvite = ( { project, addGroupModalStackOrder = 1, onRoleSelectionChange }: EmailInviteProps ) => {
	const {
		emails,
		selectedRole,
		roleOptions,
		shouldShowContactsGroupsModal,
		allEmailsValid,
		validateEmail,
		hasInvalidManagerEmails,
		invalidManagerEmails,
		onAddGroupClicked,
		onCloseContactsGroupsModal,
		onConfirmContactsGroupsModal,
		onRoleChange,
		onEmailsChange,
		onInviteMember,
		isInvitingMember
	} = useEmailInvite( { project, onRoleSelectionChange } );

	return (
		<>
			<Stack className="EmailInvite" w="100%" spacing={6}>
				<Stack spacing={4}>
					<Group align="center" spacing={6}>
						<Center bg="blue.1" p={4} style={{ borderRadius: 4 }}>
							<Icon icon="email-outlined" size={14} color="blue.5" />
						</Center>
						<Text variant="footnote-semibold" color="dark.7">Email invite</Text>
					</Group>
					<Text variant="footnote" color="dark.3">
						Only invited people can access. Login required to access the project.
					</Text>
				</Stack>
				<Group position="left" w="100%" spacing={8} noWrap align="flex-start">
					<EmailsInput
						emails={emails}
						emailValidator={validateEmail}
						role={selectedRole}
						roleOptions={roleOptions}
						onEmailsChange={onEmailsChange}
						onRoleChange={onRoleChange}
						onAddGroupClick={onAddGroupClicked}
						canManageContactGroups={project.workspace.currentUserCanCreateProject}
						projectID={project.id}
					/>
					<Button
						disabled={!allEmailsValid || isInvitingMember}
						onClick={onInviteMember}
						size="sm"
						h={38}
					>
						{isInvitingMember ? 'Inviting...' : 'Invite'}
					</Button>
				</Group>
				{hasInvalidManagerEmails && (
					<ManagersEmailsError
						workspaceID={project.workspaceID}
						emails={invalidManagerEmails}
						project={project}
					/>
				)}
			</Stack>

			{shouldShowContactsGroupsModal && (
				<ContactsGroupsModal
					onClose={onCloseContactsGroupsModal}
					onConfirm={onConfirmContactsGroupsModal}
					workspace={project.workspace}
					stackOrder={addGroupModalStackOrder}
				/>
			)}
		</>
	);
};

export default EmailInvite;
